import React from "react";
const IconWaterproof = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="56" height="56" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54" {...props}>
    <path d="M7 46h40" stroke="currentColor" strokeWidth="2" />
    <path
      d="M22.8 17.8c0 4.32 4.2 4.32 4.2 4.32m7-4.023C34 21.903 30.86 25 27 25s-7-3.097-7-6.903c0-1.596.544-3.146 1.532-4.363L27 7l5.468 6.734A6.934 6.934 0 0 1 34 18.097Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="m27.148 42.606.708.706-1.415.001.707-.707Zm14.28-15.759.705-.708 1.417 1.41-.705.71-1.417-1.412Zm2.08-.6v-1l1 1h-1ZM26.439 41.9l14.989-15.054 1.417 1.412-14.989 15.053L26.44 41.9Zm-9.232-10.65L27.855 41.9l-1.414 1.414-10.648-10.647 1.414-1.414Zm25.3 2.906v-7.91h2v7.91h-2Zm1-6.91h-7.91v-2h7.91v2Z"
      fill="currentColor"
    />
  </svg>
);
export default IconWaterproof;
